export const services = [
  {
    id: 1,
    icon: 'fa-solid fa-calendar-day fa-beat fa-2xl',
    titleKey: 'services.schedule_online',
    textKey: 'services.schedule_online_desc',
  },
  {
    id: 2,
    icon: 'fa-solid fa-credit-card fa-beat fa-2xl',
    titleKey: 'services.easy_payments',
    textKey: 'services.easy_payments_desc',
  },
  {
    id: 3,
    icon: 'fa-solid fa-notes-medical fa-beat fa-2xl',
    titleKey: 'services.online_forms',
    textKey: 'services.online_forms_desc',
  },
];
